module.exports = __webpack_public_path__ + "static/media/uploadAi.705c65a7.svg";